// extracted by mini-css-extract-plugin
export default {"editModeTitle":"Wbmo_RTIsp"};